import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestCheckBarcodeAvailability } from "./checkBarcodeAvailability.request";
import {
  CheckBarcodeAvailabilityRequestBody,
  CheckBarcodeAvailabilityResponse
} from "./checkBarcodeAvailability.types";

const useCheckBarcodeAvailability = (
  options?: MutationOptions<
    CheckBarcodeAvailabilityResponse,
    ApiServiceError<ApiError>,
    CheckBarcodeAvailabilityRequestBody
  >
) => {
  return useMutation({
    mutationFn: requestCheckBarcodeAvailability,
    ...options
  });
};

export default useCheckBarcodeAvailability;
